import {getErrorObj, getValidationMessage} from "../../../util/validationMessage";


const Input = ({ inline = false,
                 label = "",
                 name,
                 placeholder = '',
                 register,
                 validationRules = {},
                 errors =null,
                 type = 'text',
                 classes = '',
                 message}) => {

    const style = !inline ? {'top':'68%', 'fontSize':'small'} : null

  let errorName = name.replace(/\[/g, ".")
  errorName = errorName.replace(/\]/g, "")

  return (
    <div className={`${ classes } ${inline ? ' form_row_inline' : 'form_row'} ${getErrorObj(errors, name) && 'has_error'}`}>
      <label className={validationRules.required ? 'required' : ''}>{label}</label>
        <div className={`form_input ${!label && 'width_full'}`}>
        <input {...register(name, validationRules)}
               type={type}
               step={type === 'number' ? '0.01' : ''}
               placeholder={placeholder}
               className="form_global" />
      </div>
        {message && <span style={style } className="p_right_center color_danger">{message}</span>}
      {getErrorObj(errors, errorName) && <small>{getValidationMessage(getErrorObj(errors, errorName), label)}</small>}
    </div>
  );
};

export default Input;